import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, MenuItem, Alert } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DropzoneArea } from 'mui-file-dropzone';
import { v4 } from 'uuid';
const tipos = ['Telefone', 'Email', 'Pessoal', 'Mensagem'];
const DialogInteracao = ({ onClose, initial, contactos, service, ...props }) => {
    const [files, setFiles] = useState(null);
    const formik = useFormik({
        initialValues: initial ?? {},
        validationSchema: yup.object({
            dataInteracao: yup.string().required('O campo é obrigatório'),
            coreContactoId: yup.number().required('O campo é obrigatório'),
            tipo: yup.string().required('O campo é obrigatório'),
            objetivos: yup.string().required('O campo é obrigatório'),
            observacoes: yup.string().nullable(),
            dataProximaInteracao: yup.string().nullable()
        }),
        validateOnMount: false,
        onSubmit: async (values) => {
            if (files != null) {
                await service.uploadFile('Upload', 'crm', files);
            }
            onClose(values);
        }
    });
    console.log(formik);
    return (<Dialog {...props}>
      <form>
        <DialogTitle>Adicionar interação</DialogTitle>
        <DialogContent>
          <Alert severity='info'>Todos os campos marcados com * são de preenchimento obrigatório.</Alert>

          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={6} md={6} xs={12}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateTimePicker label='Data/Hora' format='DD/MM/YYYY HH:mm' value={formik.values?.dataInteracao} onChange={value => {
            formik.setFieldValue('dataInteracao', value, true);
        }} slotProps={{
            textField: {
                required: true,
                variant: 'outlined',
                name: 'dataInteracao',
                onBlur: formik.handleBlur,
                error: formik.touched.dataInteracao && Boolean(formik.errors.dataInteracao),
                fullWidth: true,
                helperText: formik.touched.dataInteracao && Boolean(formik.errors.dataInteracao) && String(formik.errors.dataInteracao) // Use boolean cause string([]) = "undefined"
            }
        }}/>
              </LocalizationProvider>
            </Grid>
            <Grid lg={6} md={6} xs={12}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateTimePicker label='Próxima Interação' format='DD/MM/YYYY HH:mm' value={formik.values?.dataProximaInteracao} onChange={value => {
            formik.setFieldValue('dataProximaInteracao', value, true);
        }} slotProps={{
            textField: {
                required: false,
                variant: 'outlined',
                name: 'dataProximaInteracao',
                onBlur: formik.handleBlur,
                error: formik.touched.dataProximaInteracao && Boolean(formik.errors.dataProximaInteracao),
                fullWidth: true,
                helperText: formik.touched.dataProximaInteracao && Boolean(formik.errors.dataProximaInteracao) && String(formik.errors.dataProximaInteracao) // Use boolean cause string([]) = "undefined"
            }
        }}/>
              </LocalizationProvider>
            </Grid>
            <Grid lg={6} md={6} xs={12}>
              <TextField label='Contacto' name='coreContactoId' value={formik.values?.coreContactoId ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.coreContactoId && Boolean(formik.errors.coreContactoId)} helperText={formik.touched.coreContactoId && formik.errors.coreContactoId} required disabled={initial.coreContactoId != null} select>
                <MenuItem value='' disabled>
                  Escolha uma opção da lista
                </MenuItem>
                {contactos.map(x => (<MenuItem value={x.id} key={x.id}>
                    {x.nome}
                  </MenuItem>))}
              </TextField>
            </Grid>
            <Grid lg={6} md={6} xs={12}>
              <TextField label='Tipo' name='tipo' value={formik.values?.tipo ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.tipo && Boolean(formik.errors.tipo)} helperText={formik.touched.tipo && formik.errors.tipo} required select>
                <MenuItem value='' disabled>
                  Escolha uma opção da lista
                </MenuItem>
                {tipos.map(x => (<MenuItem value={x} key={x}>
                    {x}
                  </MenuItem>))}
              </TextField>
            </Grid>
            <Grid lg={6} md={6} xs={12}>
              <TextField label='Objetivos' name='objetivos' required value={formik.values?.objetivos ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.objetivos && Boolean(formik.errors.objetivos)} helperText={formik.touched.objetivos && formik.errors.objetivos}/>
            </Grid>
            <Grid lg={12} md={12} xs={12}>
              <TextField multiline rows={4} label='Observações' name='observacoes' value={formik.values?.observacoes ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.observacoes && Boolean(formik.errors.observacoes)} helperText={formik.touched.observacoes && formik.errors.observacoes}/>
            </Grid>
            <Grid lg={12} xs={12}>
              <DropzoneArea initialFiles={[files]} filesLimit={1} dropzoneText='Arraste um ficheiro para esta janela ou clique para adicionar' onChange={files => {
            if (files.length > 0) {
                let t = files.pop();
                let f = new File([t], `${v4()}.${t.extension()}`, { type: t.type });
                f.dummy = t.dummy || false;
                formik.setFieldValue('anexo', f.name);
                setFiles(f);
            }
            else {
                formik.setFieldValue('anexo', undefined);
                setFiles(null);
            }
        }} onDelete={_ => {
            formik.setFieldValue('anexo', undefined);
            setFiles(null);
        }} acceptedFiles={['image/*', 'application/pdf']} showFileNames={false} showAlerts={false} showPreviewsInDropzone={true} useChipsForPreview={true} previewChipProps={{
            color: 'default',
            variant: 'filled'
        }}/>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type='button' onClick={() => onClose(undefined)}>
            Cancelar
          </Button>
          <Button onClick={() => {
            formik.handleSubmit();
        }} disabled={!formik.isValid || !formik.dirty || formik.isSubmitting} variant='contained'>
            OK
          </Button>
        </DialogActions>
      </form>
    </Dialog>);
};
export default DialogInteracao;
